import React from 'react';
import {
  CONTACT_PHONE_TEL,
  CONTACT_PHONE_WHATSAPP,
} from '../../../constants/contact';
import './SidePanel.css';

const SidePanel: React.FC = () => {
  const handleWhatsApp = () => {
    window.open(`https://wa.me/${CONTACT_PHONE_WHATSAPP}`, '_blank');
  };

  const handleInstagram = () => {
    window.open('https://www.instagram.com/draysesezim/', '_blank');
  };

  const handleFacebook = () => {
    window.open('https://www.facebook.com/draysesezim/', '_blank');
  };

  const handleYouTube = () => {
    window.open('https://www.youtube.com/@Draysesezim', '_blank');
  };

  const handlePhone = () => {
    window.open(`tel:${CONTACT_PHONE_TEL}`, '_self');
  };

  const handleEmail = () => {
    window.open('mailto:info@draysesezim.com', '_self');
  };

  return (
    <div className="side-panel">
      <div className="side-panel-content">
        {/* WhatsApp */}
        <button 
          className="side-panel-btn whatsapp-btn" 
          onClick={handleWhatsApp}
          title="WhatsApp"
        >
          <i className="fab fa-whatsapp"></i>
        </button>

        {/* Instagram */}
        <button 
          className="side-panel-btn instagram-btn" 
          onClick={handleInstagram}
          title="Instagram"
        >
          <i className="fab fa-instagram"></i>
        </button>

        {/* Facebook */}
        <button 
          className="side-panel-btn facebook-btn" 
          onClick={handleFacebook}
          title="Facebook"
        >
          <i className="fab fa-facebook-f"></i>
        </button>

        {/* YouTube */}
        <button 
          className="side-panel-btn youtube-btn" 
          onClick={handleYouTube}
          title="YouTube"
        >
          <i className="fab fa-youtube"></i>
        </button>

        {/* Phone */}
        <button 
          className="side-panel-btn phone-btn" 
          onClick={handlePhone}
          title="Call"
        >
          <i className="fas fa-phone"></i>
        </button>

        {/* Email */}
        <button 
          className="side-panel-btn email-btn" 
          onClick={handleEmail}
          title="Email"
        >
          <i className="fas fa-envelope"></i>
        </button>
      </div>
    </div>
  );
};

export default SidePanel;
